import { SectionHeader } from './LandingJourneySection'

const stats = [
  { value: '15', label: 'Jornadas', color: 'bg-brand-yellow text-brand-dark', rot: '-rotate-2' },
  { value: '120', label: 'Missões', color: 'bg-brand-green text-brand-dark', rot: 'rotate-2' },
  { value: '80', label: 'Recompensas', color: 'bg-brand-pink text-white', rot: '-rotate-1' },
  { value: '#1', label: 'Ranking Nacional', color: 'bg-brand-cyan text-brand-dark', rot: 'rotate-1' }
]

export function LandingStatsSection() {
  return (
    <section id="ranking" className="relative overflow-hidden bg-white py-24 md:py-32">
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, var(--color-brand-dark) 1px, transparent 0)',
          backgroundSize: '24px 24px'
        }}
      />
      <div className="absolute -top-32 right-0 size-[28rem] rounded-full bg-brand-purple/25 blur-3xl" />
      <div className="absolute -bottom-24 left-0 size-96 rounded-full bg-brand-cyan/25 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeader
          eyebrow="Gamificação"
          title={
            <>
              Aprender{' '}
              <span className="font-hl text-brand-magenta">vicia</span> quando
              vira jogo.
            </>
          }
          subtitle="Toda ação conta. Toda conquista marca."
        />

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className={`${s.color} ${s.rot} rounded-[2rem] p-6 shadow-[0_10px_0_var(--color-brand-dark)] ring-1 ring-black/10`}
            >
              <div className="font-hl text-7xl leading-none md:text-8xl">{s.value}</div>
              <div className="mt-3 text-sm font-extrabold uppercase tracking-widest">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
